import styled from 'styled-components'
import {size, padding} from '../../styles/template';

export const InnerContainer = styled.div`
    max-width: 100%;
    margin: 0 auto;
    width: ${size.laptop};
    padding: 0 ${padding.small};
`;



